/* 
eslint-disable no-mixed-operators
*/
/* 
eslint-disable react-hooks/exhaustive-deps
*/
import React from 'react';
import { makeStyles } from '../../theme';
import Textfield from '../textfield';
import {AttachFileIcon} from '../icons';
import Box from '../layout/box';
import cx from 'classnames';
import * as componentStyling from '../styling';

const styles = makeStyles({
	fileSelect: {
		width:'100%'
	}
});

let controlIdCount = 0;

function getControlId() {
	return controlIdCount++;
}

function fileLoader({load} = {}) {
	const reader = new FileReader();
	reader.onload = e => load && load(e.target.result);
	return file => file && reader.readAsDataURL(file);
}

const PREVIEW_MAP = {
	'image/':ImagePreview
}

function getPreview(mime = "") {
	const previewKeys = Object.keys(PREVIEW_MAP);
	const acceptList = mime.split(",");
	const previews = acceptList.reduce((acc, mime) => {
		const validPreviews = previewKeys
			.filter(key => mime.indexOf(key) > -1)
			.map(key => PREVIEW_MAP[key]);
		return [...acc, ...validPreviews];
	}, []);
	return previews && previews.length && previews[0];
}

function getPreviewForFiles(files) {
	if(!files)return;
	const mime = Array.isArray(files) ? files[0].type : files.type;
	return getPreview(mime);
}

const File = React.memo(({preview, ...props}) => {
	return preview ? <PreviewFile {...props}/> : <FilePicker {...props}/>;
});

export default File;

const FilePicker = React.memo(({label, multiple, onChange, ...props}) => {
	const classes= styles();
	const [cid] = React.useState(`upload_${getControlId()}`);
	const [files, setFilesCore] = React.useState([]);
	const setFiles = files => {
		setFilesCore(files);
		onChange && onChange(multiple ? files : files.length && files[0]);
	}
	const inputEl = React.useRef();
	const handleInputChange = () => inputEl.current ? setFiles([...inputEl.current.files] || []) : setFiles([]);
	const pickFiles = () => inputEl && inputEl.current.click();
	const handleEnterKey = ev => {
		if (ev.key === 'Enter') {
			ev.stopPropagation();
			ev.nativeEvent.stopImmediatePropagation();
			ev.preventDefault();
			pickFiles();
		  }
	}
	React.useEffect(() => {
		const currInputEl = inputEl.current; // Saving `inputEl.current` was necessary to run cleanup function properly.
		currInputEl.addEventListener('change', handleInputChange);
		return () => currInputEl.removeEventListener('change', handleInputChange);
	}, [inputEl]);
	const filesText = files.reduce((acc, file) => `${acc}${acc!=='' ? '\n' :''}${file.name}`, "");
	const handleClick = () => pickFiles();

	//<label htmlFor={cid}></label> // Might need for browser compat.
	return(
		<Box className={cx(componentStyling.Control)}>
			<Textfield 
				label={label} 
				endadornment={<AttachFileIcon/>}
				multiline
				value={filesText}
				readOnly
				onClick={handleClick}
				className={classes.fileSelect}
				onKeyPress={handleEnterKey}
				/>
			<input 
				ref={inputEl}
				type="file" 
				tabIndex="-1"
				id={cid} 
				name={cid} 
				style={{opacity:0, width:'1px', height:'1px'}}
				multiple={multiple}
				{...props}
				></input>
		</Box>
	)
})

const PreviewFile = React.memo(props => {
	const [files, setFiles] = React.useState();
	const [{Preview, fileData} = {}, setPreviewData] = React.useState();

	React.useEffect(() => {
		if(files) {
			const preview = getPreviewForFiles(files);
			if(preview) {
				fileLoader({
					load:data => setPreviewData({Preview:preview, fileData:data})
				})(files)
			} else {
				setPreviewData({});
			}
		} else {
			setPreviewData({});
		}
		
	}, [files]);

	return(
		<Box className={cx(componentStyling.Control)}>
			{Preview && <Preview fileData={fileData} {...props}/>}
			<File 
				{...props} 
				onChange={setFiles} />
		</Box>
	);
})

const imgFileStyles = makeStyles({
	img: {
		maxWidth:'200px',
		maxHeight:'200px',
		objectFit:'contain'
	}
});

function ImagePreview({fileData, maxPreviewWidth, maxPreviewHeight, maxPreviewSize}) {
	const classes= imgFileStyles();
	const imgConfigStyles = (maxPreviewSize || maxPreviewWidth || maxPreviewHeight) ? (
		{
			maxWidth:maxPreviewWidth || maxPreviewSize,
			maxHeight:maxPreviewHeight || maxPreviewSize
		}
	) : {};
	return (
		<img 
			src={fileData && fileData || ''} 
			className={classes.img} 
			style={imgConfigStyles}
			alt="" />
	);
}